// extracted by mini-css-extract-plugin
module.exports = {"SocialMedia":"SocialMedia_SocialMedia__2j2n8"};